<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Danh sách cấu hình dịch vụ tính KPI</h1>
      <div class="btn-group float-right">
        <DraggableTable
          :naming="$route.name"
          v-model="fieldsTable"
          @change="filterTable = $event"
        />
        <button class="font-medium f12 btn btn-outline-secondary">
          <i class="bx bx-download"></i><span>&nbsp;</span>Xuất file
        </button>
        <button class="font-medium f12 btn btn-outline-secondary" @click.prevent="openCreateModal">
          <i class="bx bx-plus-circle"></i><span>&nbsp;</span>Thêm mới
        </button>
      </div>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search">
          <div class="form-group">
            <Select2
              v-model="search.typeService"
              :options="serviceTypeOption"
              placeholder="Loại dịch vụ"
              @change="changeServiceTypeOption"
            >
            </Select2>
          </div>
          <div class="form-group">
            <Select2 v-model="search.service" :options="optionService" placeholder="Dịch vụ">
            </Select2>
          </div>
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              v-model="dateRange"
              :locale-data="Config.localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 11.5em; margin-left: -5px !important"
                  class="pt-1 text-center"
                >
                  {{ picker.startDate | formatDate }} -
                  {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Ngày tạo
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group form-group-action">
            <button
              type="button"
              class="btn btn-primary hc-37 mr-2 pt-2"
              @click.prevent="submitSearchForm"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>
            <button
              type="button"
              class="btn btn-outline-light hc-37 mr-2 pt-2"
              @click.prevent="clearSearch"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            Tổng: <strong class="text-primary">{{ pagination.total }}</strong>
            <b-table
              class="mt-1"
              :busy.sync="loading"
              sticky-header
              hover
              responsive
              :items="dataLists"
              :fields="filterTable"
              :fixed="true"
              :bordered="true"
            >
              <template #head(index)>
                <div class="text-center">STT</div>
              </template>
              <template #cell(index)="data">
                <div class="text-center">{{ getIndex(data.index) }}</div>
              </template>
              <template #cell(typeService)="data">
                {{ data.item.typeService | serviceType }}
              </template>
              <template #cell(packageService)="data">
                {{ data.item.packageService | packageService }}
              </template>
              <template #cell(softwareCategory)="data">
                {{
                  data.item.softwareCategory
                    ? getNameSoftwareCategory(data.item)
                    : data.item.categoryCode
                }}
              </template>
              <template #cell(kpiStandard)="data">
                <div class="text-right">{{ data.item.kpiStandard }}</div>
              </template>
              <template #cell(duration)="data">
                <div class="text-right">{{ data.item.duration }}</div>
              </template>
              <template #cell(createdTime)="data">
                {{ data.item.createdTime | formatDate }}
              </template>
              <template #cell(status)="data">
                {{ data.item.status | statusKPI }}
              </template>
              <template #cell(action)="data">
                <b-dropdown
                  class="text-center"
                  variant="outline-light"
                  v-if="dataPermission && dataPermission.includes('CNPS_SCON_INFO_BY_CODE')"
                >
                  <b-dropdown-item
                    type="button"
                    class="dropdown-item"
                    @click="clickViewDetail(data.item)"
                  >
                    <i class="bx bx-show-alt"></i> Chi tiết
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
          </div>
        </div>
        <div class="pagination-bottom">
          <b-pagination
            class="mr-2 fl-right"
            v-model="search.page"
            :total-rows="pagination.total"
            :per-page="search.limit"
          >
          </b-pagination>
        </div>
        <VueLoadingOverlay :active.sync="loading" :is-full-page="true"> </VueLoadingOverlay>
        <b-modal id="modal-scoped" v-model="createModal">
          <template #modal-header="{ close }">
            <h5>Thêm mới dịch vụ tính KPI</h5>
            <b-button size="sm" variant="light" @click="close()"> x </b-button>
          </template>
          <b-form-group>
            <label>Loại dịch vụ <span class="text-red">(*)</span></label>
            <Select2
              v-model="paramsItem.typeService"
              :options="Config.serviceType"
              placeholder="Loại dịch vụ"
              @change="changeServiceTypeItem"
            >
            </Select2>
          </b-form-group>
          <b-form-group>
            <label>Dịch vụ <span class="text-red">(*)</span></label>
            <Select2
              v-model="paramsItem.service"
              :options="optionServiceLoad"
              placeholder="Dịch vụ"
              ref="serviceInput"
              v-if="paramsItem.typeService === 'SELL'"
            >
            </Select2>
            <b-form-input
              ref="serviceInput"
              v-model="paramsItem.service"
              v-if="paramsItem.typeService === 'PAYMENT'"
            ></b-form-input>
          </b-form-group>
          <b-form-group v-if="paramsItem.typeService === 'SELL'">
            <label>Gói <span class="text-red">(*)</span></label>
            <Select2
              v-model="paramsItem.packageService"
              :options="packageServiceOption"
              placeholder="Gói"
            >
            </Select2>
          </b-form-group>
          <b-form-group>
            <label
              >Thiết bị
              <span class="text-red" v-if="paramsItem.typeService === 'PAYMENT'">(*)</span></label
            >
            <select2-multiple-control
              v-model="paramsItem.softwareCategory"
              :options="listCatDeviceSell"
              placeholder="Thiết bị"
              v-if="paramsItem.typeService === 'SELL'"
            >
            </select2-multiple-control>
            <select2
              v-model="paramsItem.categoryId"
              :options="listCatDevicePayment"
              placeholder="Thiết bị kèm theo"
              v-if="paramsItem.typeService === 'PAYMENT'"
            >
            </select2>
          </b-form-group>
          <b-form-group label="Năm hợp đồng" v-if="paramsItem.typeService === 'SELL'">
            <b-form-input v-model.number="paramsItem.duration"></b-form-input>
          </b-form-group>
          <b-form-group>
            <label>KPI tiêu chuẩn <span class="text-red">(*)</span></label>
            <b-form-input v-model.number="paramsItem.kpiStandard"></b-form-input>
          </b-form-group>
          <b-form-group label="Ghi chú">
            <b-form-input v-model="paramsItem.note"></b-form-input>
          </b-form-group>
          <p class="text-danger" v-show="errorMessage">
            <i class="bx bx-error-alt"></i> {{ errorMessage }}
          </p>
          <template #modal-footer="{ cancel }">
            <b-button variant="light" @click="cancel()"> Bỏ qua </b-button>
            <b-button variant="primary" @click="createItem()"> Lưu </b-button>
          </template>
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
  import { KpiSaleConfigService } from '@/services/kpi.sale.config.service'
  import { DeviceService } from '@/services/device.service'
  import cloneDeep from 'lodash/cloneDeep'
  import Config from '@/thirdParty/config'
  import moment from 'moment'

  const fieldsTable = [
    { key: 'index', label: 'STT' },
    { key: 'typeService', label: 'Loại dịch vụ' },
    { key: 'service', label: 'Dịch vụ' },
    { key: 'packageService', label: 'Gói' },
    { key: 'softwareCategory', label: 'Thiết bị kèm theo' },
    { key: 'kpiStandard', label: 'KPI tiêu chuẩn' },
    { key: 'duration', label: 'Năm hợp đồng' },
    { key: 'createdTime', label: 'Ngày tạo' },
    { key: 'note', label: 'Ghi chú' },
    { key: 'status', label: 'Trạng thái' },
    { key: 'action', label: 'Thao tác', fixIndex: 999, class: 'text-center' },
  ]

  export default {
    data() {
      return {
        dataLists: [],
        search: {
          createdDateFrom: '',
          createdDateTo: '',
          service: '',
          typeService: null,
          limit: 50,
          page: 1,
        },
        pagination: {
          total: 0,
        },
        Config,
        dateRange: {
          startDate: '',
          endDate: '',
        },
        serviceTypeOption: [
          { id: '0', text: 'Tất cả' },
          { id: 'PAYMENT', text: 'Thanh toán' },
          { id: 'SELL', text: 'Bán hàng' },
        ],
        listService: {},
        optionService: [],
        fieldsTable,
        filterTable: fieldsTable,
        loading: false,
        createModal: false,
        optionServiceLoad: [],
        paramsItem: {
          categoryCode: '',
          categoryId: '',
          duration: 0,
          typeService: 'PAYMENT',
          service: '',
          packageService: '',
          kpiStandard: 0,
          softwareCategory: [],
          note: '',
        },
        initItem: {
          categoryCode: '',
          categoryId: '',
          duration: 0,
          typeService: 'PAYMENT',
          service: '',
          packageService: '',
          kpiStandard: 0,
          softwareCategory: [],
        },
        packageServiceOption: Config.typeContractPackage,
        listCatDeviceSell: [],
        listCatDevicePayment: [],
        errorMessage: '',
      }
    },
    async created() {
      await this.getCatDeviceAll()
      this.fetchData()
      this.getServiceList()
    },

    watch: {
      'search.page': function () {
        this.fetchData()
      },
      'search.limit': function () {
        this.fetchData()
      },
    },

    methods: {
      async submitSearchForm() {
        this.search.page = 1
        this.fetchData()
      },
      clearSearch() {
        this.search = {
          limit: 20,
          page: 1,
        }
        this.dateRange = {
          startDate: null,
          endDate: null,
        }
        this.fetchData()
      },
      changeServiceTypeOption() {
        if (this.search.typeService != '') {
          this.optionService = this.listService[this.search.typeService]
        }
      },
      async fetchData() {
        try {
          this.loading = true
          const search = cloneDeep(this.search)
          if (this.dateRange.startDate && this.dateRange.endDate) {
            search.createdDateTo = moment(this.dateRange.endDate).endOf('day').valueOf()
            search.createdDateFrom = moment(this.dateRange.startDate).startOf('day').valueOf()
          } else {
            delete search.createdDateFrom
            delete search.createdDateTo
          }
          if (search.typeService == '' || search.typeService == '0') search.typeService = null
          if (search.service == '') delete search.service

          const data = await KpiSaleConfigService.kpiPolicyConfig(search)
          if (data.success) {
            this.dataLists = data.data.standardResList
            this.pagination.total = data.data.count ? data.data.count : 0
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },
      async createItem() {
        try {
          this.loading = true
          if (this.paramsItem.typeService == 'SELL') {
            delete this.paramsItem.categoryId
            delete this.paramsItem.categoryCode
          } else if (this.paramsItem.typeService == 'PAYMENT') {
            if (this.paramsItem.categoryId != '') {
              this.listCatDevicePayment.forEach(value => {
                if (value.id === this.paramsItem.categoryId) {
                  this.paramsItem.categoryCode = value.text
                }
              })
            }
            delete this.paramsItem.packageService
            delete this.paramsItem.softwareCategory
          }
          const data = await KpiSaleConfigService.kpiPolicyConfigCreate(this.paramsItem)
          if (data.success) {
            this.createModal = false
            this.fetchData()
          }
        } catch (error) {
          this.errorMessage = error
        } finally {
          this.loading = false
        }
      },
      joinArray(item) {
        return item.join(', ')
      },
      async changeServiceTypeItem() {
        if (this.paramsItem.typeService != '') {
          this.optionServiceLoad = this.listService[this.paramsItem.typeService]
        }
        this.paramsItem.softwareCategory = []
        if (this.paramsItem.typeService == 'PAYMENT') {
          this.paramsItem.service = ''
        }
        this.errorMessage = ''
        // await this.getListCatDevice();
      },
      async openCreateModal() {
        this.paramsItem = cloneDeep(this.initItem)
        this.errorMessage = ''
        this.createModal = true
        if (this.paramsItem.typeService != '') {
          this.optionServiceLoad = this.listService[this.paramsItem.typeService]
        }
        // await this.getListCatDevice();
      },
      async getListCatDevice() {
        const diviceParams = {
          page: 1,
          limit: 1000,
          type: this.paramsItem.typeService == 'PAYMENT' ? 'CARD_SWIPE_MACHINE' : 'SELLING_MACHINE',
        }
        const response = await DeviceService.listCatDevice(diviceParams)
        if (response.success) {
          const categoryList = response.data.categoryList
          const listCatDeviceSell = []
          const listCatDevicePayment = []
          if (categoryList.length > 0) {
            categoryList.forEach(value => {
              const tmpSell = {
                id: value.abbreviation,
                text: value.name,
              }
              listCatDeviceSell.push(tmpSell)

              const tmpPayment = {
                id: value.id,
                text: value.name,
              }
              listCatDevicePayment.push(tmpPayment)
            })
          }
          this.listCatDeviceSell = listCatDeviceSell
          this.listCatDevicePayment = listCatDevicePayment
        }
      },
      clickViewDetail(item) {
        // this.$router.push({ path: `/kpi-sale/config/view/${item.id}` });
        window.open(`/kpi-sale/config/view/${item.id}`, '_blank')
      },
      async getServiceList() {
        const data = await KpiSaleConfigService.getServiceList()
        if (data.success) {
          if (data.data.groupService.length > 0) {
            data.data.groupService.forEach(value => {
              if (value.service !== '' && value.detail.length > 0) {
                this.listService[value.service] = []
                value.detail.forEach(item => {
                  const tmp = { id: item.code, text: item.name }
                  this.listService[value.service].push(tmp)
                })
              }
            })
          }
        }
      },
      async getCatDeviceAll() {
        this.paramsItem.typeService = 'PAYMENT'
        await this.getListCatDevice()
        this.paramsItem.typeService = 'SELL'
        await this.getListCatDevice()
      },
      getNameSoftwareCategory(item) {
        if (
          item.typeService == 'SELL' &&
          item.softwareCategory.length > 0 &&
          this.listCatDeviceSell.length > 0
        ) {
          const mapData = item.softwareCategory.reduce((arr, current) => {
            const findName = this.listCatDeviceSell.find(value => value.id == current)
            arr.push(findName ? findName.text : current)
            return arr
          }, [])
          return mapData.join(', ')
        }

        if (
          item.typeService == 'PAYMENT' &&
          item.softwareCategory.length > 0 &&
          this.listCatDevicePayment.length > 0
        ) {
          const mapData = item.softwareCategory.reduce((arr, current) => {
            const findName = this.listCatDevicePayment.find(value => value.id == current)
            arr.push(findName ? findName.text : current)
            return arr
          }, [])
          return mapData.join(', ')
        }
      },
    },
  }
</script>
<style scoped>
  .text-red {
    color: red;
  }
  .pointer {
    cursor: pointer;
  }
</style>
